import React from "react";
import { Box, Typography } from "@mui/material";
import { Features } from "../../common/const";
import { Hexagon } from "@mui/icons-material";

export const FeatureHex = ({
    feature,
    containerSx = {},
    contentTop = '50%',
}) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', ...containerSx }}>
            <Hexagon sx={{ color: feature.color, fontSize: 380 }} /> {/* Set to 380 */}
            <Box
                sx={{
                    position: 'absolute',
                    top: contentTop,
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '250px', // Adjusted width for 380 size
                }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={1}
                flexDirection="column"
            >
                {feature.images}
                <Typography
                    color={feature.fontColor}
                    fontWeight={600}
                    fontSize={22} // Slightly reduced from 24 for better fit
                    textAlign="center"
                >
                    {feature.title}
                </Typography>
            </Box>
        </Box>
    );
};

const layout = [
    [
        { index: 0, sx: { mr: -1.5 }, top: '50%' },
        { index: 1, sx: { ml: -13, mt: -18.5 }, top: '35%' },
        { index: 4, sx: { ml: -15 }, top: '50%' },
        { index: 5, sx: { ml: -15, mt: -18.5 }, top: '35%' },
    ],
    [
        { index: 2, sx: { mr: -1.5, mt: -3 }, top: '50%' },
        { index: 3, sx: { ml: -13, mt: -21.5 }, top: '35%' },
        { index: 7, sx: { ml: -15, mt: -3 }, top: '50%' },
        { index: 6, sx: { ml: -15, mt: -21.5 }, top: '35%' },
    ],
    [
        { index: 8, sx: { ml: -32, mt: -22.5 }, top: '50%' },
    ],
];

const Feature = ({
    featureRef
}) => {
    return (
        <Box
            id="feature"
            ref={featureRef}
            sx={{
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1,
                    backgroundImage: `url('/Images/featuresbackground1.png')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                }}
            />
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 3,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 3,
                    maxWidth: '1400px',
                    mx: 'auto',
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 2,
                    }}
                >
                    <Box width={{ xs: '100%', md: '40%' }}>
                        <Box
                            display="flex"
                            gap={1.5}
                            mb={1.6}
                        >
                            <Box sx={{ background: '#306FE8', width: '4.5%', borderRadius: 0.6 }}></Box>
                            <Typography color="White" fontSize={17} fontWeight={600}>Complete Feature Set</Typography>
                        </Box>
                        <Typography fontSize={{ xs: 28, md: 38 }} color="White" fontWeight={600} sx={{ lineHeight: 1.1 }}>Dream College Planner Empowers Every step of your Students college journey</Typography>
                    </Box>
                    <Box width={{ xs: '100%', md: '26%' }}>
                        <Typography color="White" fontSize={16} fontWeight={600}>From sign-up to admission, the platform brings together 9 powerful features designed to simplify planning, reduce stress, and help students stay on track toward their dream college.</Typography>
                    </Box>
                </Box>
                
                <Box 
                    sx={{ 
                        m: '40px auto',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        overflow: 'visible',
                    }}
                >
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        transform: {
                            xl: 'scale(1)', // No scaling needed with 380
                        },
                        transformOrigin: 'center center',
                    }}>
                        {layout.map((row, rowIndex) => (
                            <Box
                                key={rowIndex}
                                display="flex"
                                justifyContent="center"
                                mt={rowIndex === 0 ? 10 : rowIndex === 1 ? -7 : -6} // Adjusted margins
                            >
                                {row.map(({ index, sx, top }) => (
                                    <FeatureHex
                                        key={index}
                                        feature={Features[index]}
                                        containerSx={sx}
                                        contentTop={top}
                                    />
                                ))}
                            </Box>
                        ))}
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}

export default Feature;